<app-navigation></app-navigation>
<div id="main">
	<app-sidenav></app-sidenav>
	<div id="content">
		@if (router.url !== "/homescreen") {
			<app-breadcrumb></app-breadcrumb>
		}
		<div id="router" class="d-flex flex-column" cdkScrollable [@routeAnimations]="getState(o)">
			<router-outlet #o="outlet"></router-outlet>
		</div>
		<app-information-banner></app-information-banner>
	</div>
</div>

<app-message></app-message>
